import type React from 'react';

import styles from './styles';
import moment from 'moment-timezone';

import {
  type MediaRequest,
  MediaType,
  Severity,
} from '@cobliteam/common-types';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import {
  CircleDivider,
  ContentLoader,
  DescriptionListDefault,
  DescriptionListMedium,
} from '@cobliteam/base-components';

import useMediaStore from '../../../../store/zustand/useMediaStore';
import { SeverityTag } from '../../../MediaTags';

export interface MediaDialogBodyProps {
  isFetchingMediaRows?: boolean;
}

const MediaDialogBody: React.FC<MediaDialogBodyProps> = ({
  isFetchingMediaRows,
}) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);

  const { data: mediaView } = useGetMediaView(mediaViewId);

  const mediaData = mediaView?.mediaInfo;

  if (!mediaData || isFetchingMediaRows) {
    return (
      <div className={styles.body}>
        <div className={styles.alignItems}>
          <DescriptionListMedium>Data do vídeo:</DescriptionListMedium>
          <ContentLoader key={0} width={132} height={16}>
            <rect x='0' y='0' width='132' height='16' />
          </ContentLoader>
        </div>
      </div>
    );
  }

  const { timestamp, mediaType } = mediaData;
  const mediaDetails = mediaData?.mediaDetails as MediaRequest;

  const dateTime = moment(timestamp).format('DD/MM/YYYY HH:mm:ss');
  const mediaCategory =
    mediaType === MediaType.TIMELAPSE
      ? 'resumo do trajeto'
      : 'vídeo de um trecho';
  const isEventVideo =
    mediaData && mediaData.mediaType === MediaType.EVENT_VIDEO;

  const renderVideoInfo = () => {
    if (isEventVideo) {
      return (
        <div className={styles.alignItems}>
          <DescriptionListMedium>Gravidade do evento:</DescriptionListMedium>
          <SeverityTag severity={mediaData.severity || Severity.SEVERE} />
        </div>
      );
    }

    return (
      <>
        <div className={styles.alignItems}>
          <DescriptionListMedium>Categoria:</DescriptionListMedium>
          <DescriptionListDefault>{mediaCategory}</DescriptionListDefault>
        </div>
        {mediaDetails?.createdBy?.fullName ? (
          <>
            <CircleDivider />
            <div className={styles.alignItems}>
              <DescriptionListMedium>Solicitante:</DescriptionListMedium>
              <DescriptionListDefault>
                {mediaDetails.createdBy.fullName}
              </DescriptionListDefault>
            </div>
          </>
        ) : undefined}
      </>
    );
  };

  return (
    <div className={styles.body}>
      <div className={styles.alignItems}>
        <DescriptionListMedium>Data do vídeo: </DescriptionListMedium>
        <DescriptionListDefault>{dateTime}</DescriptionListDefault>
      </div>
      <CircleDivider />
      {renderVideoInfo()}
    </div>
  );
};

export default MediaDialogBody;
